module.exports = __webpack_public_path__ + "img/sam-pfp.03ba6ea5.png";